import {Button, Typography} from 'antd';
import CartItems from './CartItems';
import ShippingAddress from './ShippingAddress';
import ShopifyNotes from './ShopifyNotes';
import ShippingCharges from './ShippingCharges';
import ShippingTags from './ShippingTags';
import OrderSection from './OrderSection';
import DiscountSection from './DiscountSection';
const {Text} = Typography;

const  CartSection = ({
  toggleCartScreen,
  updateAddress,
  updateAllAddressData,
  onPhoneNumberUpdate,
  updateCartItems,
  storeState,
  productItems,
  updateShippingCharges,
  updateTags,
  updateNotes,
  updateDiscountConfig,
  fetchShippingCharges,
  createCodOrder,
  sendPaymentLink,
  copyCheckoutLink,
  shopUrl,
  isSendInChatDisabled,
  isWhatsappCheckoutEnabled,
  currencySymbol,
  maxDiscountPercentage,
  maxDiscountAmount,
  isDiscountOverLimit
}) => {
  console.log(storeState, 'storeState');
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '10px',
        alignItems: 'flex-start',
        background: '#F8FAFD',
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
          height: '5%',
        }}
      >
        <Button
          type="text"
          style={{display: 'flex', alignItems: 'center', gap: '10px'}}
          onClick={toggleCartScreen}
        >
          <img width={25} height={25} src={'/backButton.svg'} alt="back" />
          <Text style={{fontSize: '16px', fontWeight: '500', color: '#3C4858'}}>
            Cart
          </Text>
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          width: '100%',
          height: '90%',
          overflowY: 'auto',
        }}
      >
        <CartItems
          updateCartItems={updateCartItems}
          cartItems={storeState.cart_items}
          productItems={productItems}
          currencySymbol={currencySymbol}
        />
        <ShippingAddress
          updateAddress={updateAddress}
          updateAllAddressData={updateAllAddressData}
          shippingAddress={storeState.shipping_details}
          onPhoneNumberUpdate={onPhoneNumberUpdate}
        />
        <ShopifyNotes
          notes={storeState.notes}
          updateNotes={updateNotes}
        />
        <ShippingTags
          tags={storeState.tags}
          updateTags={updateTags}
        />
        <ShippingCharges
          fetchShippingCharges={fetchShippingCharges}
          shippingCharges={storeState.shipping_charges}
          updateShippingCharges={updateShippingCharges}
          shippingAddress={storeState.shipping_details}
        />
        <DiscountSection
          discountConfig={storeState.discountConfig}
          updateDiscountConfig={updateDiscountConfig}
          maxDiscountPercentage={maxDiscountPercentage}
          maxDiscountAmount={maxDiscountAmount}
          isDiscountOverLimit={isDiscountOverLimit}
          currencySymbol={currencySymbol}
        />
        <OrderSection
          cartItems={storeState.cart_items}
          productItems={productItems}
          shippingCharges={storeState.shipping_charges}
          createCodOrder={createCodOrder}
          discountConfig={storeState.discountConfig}
          sendPaymentLink={sendPaymentLink}
          copyCheckoutLink={copyCheckoutLink}
          shopUrl={shopUrl}
          isSendInChatDisabled={isSendInChatDisabled}
          isWhatsappCheckoutEnabled={isWhatsappCheckoutEnabled}
          currencySymbol={currencySymbol}
          isDiscountOverLimit={isDiscountOverLimit}
        />
      </div>
    </div>
  );
};

export default CartSection;
